module.exports = __webpack_public_path__ + "img/value.b86735b0.png";